import { CommonIP } from '@model/ftf-api.model';
import { createReducer, on } from '@ngrx/store';

import * as HistoryActions from '../actions/history.actions';

export interface HistoryState {
  items: CommonIP[];
  error?: string;
}

export const initialHistoryState: HistoryState = {
  items: [],
  error: undefined,
};

export const historyReducer = createReducer(
  initialHistoryState,
  on(HistoryActions.loadHistorySuccess, HistoryActions.addHistoryItemSuccess, (state, { items }) => ({ ...state, items })),
  on(HistoryActions.loadHistoryFailure, HistoryActions.addHistoryItemFailure, (state, { error }) => ({ ...state, error }))
);
